export default __webpack_public_path__ + "static/media/3-first_vacation_skiing.49cbf029.jpg";